module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "focus-warp"
  }, [_c('carousel', {
    attrs: {
      "data": _vm.list,
      "pcXrsdGoodsAdv": _vm.pcXrsdGoodsAdv
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-251d74d0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/home-page/banner/index.vue
// module id = 1552
// module chunks = 1